import type { IngestedEventSample } from '@vy/types';
import { vyDate } from '@vy/utils';

import { formatDate } from '../../../../utils/date';
import { sanitizeCsvString } from '../../../../utils/string';
import { EVENTS_COLUMNS_KEYS } from '../events-page-components/EventsTable/events-table-consts/events-columns';
import { EVENTS_PAGE_CSV_HEADERS } from './events-page-csv-headers';

type CSVFieldOrder = {
  field: string;
  header: string;
  getValue: (event: IngestedEventSample) => string;
};

const CSV_FIELD_ORDER: CSVFieldOrder[] = [
  {
    field: EVENTS_COLUMNS_KEYS.NAME,
    header: EVENTS_PAGE_CSV_HEADERS.NAME,
    getValue: (e) => sanitizeCsvString(e.name),
  },
  {
    field: EVENTS_COLUMNS_KEYS.TIMESTAMP,
    header: EVENTS_PAGE_CSV_HEADERS.TIMESTAMP,
    getValue: (e) => formatDate(vyDate(e.timestamp), 'MM-DD-YYYY HH:mm:ss'),
  },
  {
    field: EVENTS_COLUMNS_KEYS.REF,
    header: EVENTS_PAGE_CSV_HEADERS.REF,
    getValue: (e) => sanitizeCsvString(e.ref),
  },
  {
    field: EVENTS_COLUMNS_KEYS.CUSTOMER_ALIAS,
    header: EVENTS_PAGE_CSV_HEADERS.CUSTOMER_ALIAS,
    getValue: (e) => sanitizeCsvString(e.customerAlias),
  },
  {
    field: EVENTS_COLUMNS_KEYS.CUSTOMER_NAME,
    header: EVENTS_PAGE_CSV_HEADERS.CUSTOMER_NAME,
    getValue: (e) => sanitizeCsvString(e.customerName ?? '-'),
  },
  {
    field: EVENTS_COLUMNS_KEYS.AFFECTED_METERS,
    header: EVENTS_PAGE_CSV_HEADERS.AFFECTED_METERS,
    getValue: (e) => sanitizeCsvString(String(e.affectedMeters ?? '-')),
  },
];

export function generateEventsCSV(events: IngestedEventSample[]) {
  const headers = CSV_FIELD_ORDER.map((item) => item.header);
  const rows = events.map((event) => {
    const values = CSV_FIELD_ORDER.map((item) => item.getValue(event));
    return values.join(',');
  });

  return `${headers.join(',')}\n${rows.join('\n')}`;
}
